import axios from "axios";
import { BASE_URL } from "../appConstants";

import { getTokenFromLocalStorage } from "./../helpers/localStorage";

const DEVELOPMENT_URL = BASE_URL;

const ajaxApi = axios.create({
  baseURL: DEVELOPMENT_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "content-security-policy":
      "default-src https: 'unsafe-eval' 'unsafe-inline'; object-src 'none'",
  },
});

let tokenFromLocalStorage = getTokenFromLocalStorage();

if (tokenFromLocalStorage) {
  ajaxApi.defaults.headers.common["Authorization"] =
    "Token " + tokenFromLocalStorage;
} else {
  delete ajaxApi.defaults.headers.common["Authorization"];
}

export default ajaxApi;
